import { render, staticRenderFns } from "./AppBarNotifications.vue?vue&type=template&id=024e5dd3"
import script from "./AppBarNotifications.vue?vue&type=script&lang=js"
export * from "./AppBarNotifications.vue?vue&type=script&lang=js"
import style0 from "./AppBarNotifications.vue?vue&type=style&index=0&id=024e5dd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports